import { PopupTooltip } from '@teamsnap/teamsnap-ui';
import { FormPill, validate } from 'frontend-toolkit';
import * as React from 'react';
import { ParticipantGroup, FeeType } from './types';
import validationSchema from './validationSchema';

type GroupFeeProps = {
  handleEventChange: (event: any) => void;
  currency: {
    name: string;
    symbol: string;
  };
  formFees: FeeType[];
  formGroups: ParticipantGroup[];
  isSavedGroupsLoading: boolean;
};

const GroupFees: React.FC<GroupFeeProps> = ({
  handleEventChange,
  currency,
  formFees,
  formGroups,
  isSavedGroupsLoading,
}) => {
  const [errors, setErrors] = React.useState({});

  const handleApplyAll = (value) => {
    const list = formFees.map((fee) => {
      const updatedFee = { ...fee, amount: value };
      return updatedFee;
    });
    handleEventChange(list);
  };

  const getUpdatedFormFees = (groupFee, groupId, value) => {
    const list = formFees;
    const index = formFees.findIndex((object) => object.id === groupId);
    const obj = {
      ...groupFee,
      ...{ amount: value },
    };

    if (index !== -1) {
      formFees[index] = obj;
    } else {
      list.push(obj);
    }

    return list;
  };

  const validateFeeAmount = (groupId, amountValue) => {
    const newErrors = errors;
    newErrors[groupId] = validate({ validation: validationSchema.fees, value: amountValue });
    setErrors(newErrors);
  };

  const sortFormGroups = () => {
    const grouping = [...formGroups];

    const sortedGroups = grouping?.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    return sortedGroups;
  };

  const formatGroupFees = () =>
    sortFormGroups()
      .filter((fg) => fg.active)
      .map((group, idx) => {
        const feeDefault = { amount: '', id: group.id };
        const groupFee = formFees.find((fee) => fee.id === group.id) || feeDefault;

        return (
          <div key={group.id} className="group-fee-item-wrapper">
            <div className="group-fee-name-wrapper">
              <PopupTooltip
                mods="u-block u-textEllipsis u-textNoWrap"
                text={group.name}
                textHighlightColor="u-colorNeutral9"
                ariaDescribeBy={group.name}
              >
                <h3 className="group-fee-name">
                  <strong>{group.name}</strong>
                </h3>
              </PopupTooltip>
            </div>

            <div className="group-fee-input-wrapper">
              <FormPill
                style={{ width: '60%' }}
                key={idx}
                id={idx}
                type="currency"
                name="fee"
                placeholder="0.00"
                text={groupFee.amount}
                currency={currency}
                errors={errors ? errors[group.id] : null}
                onChange={(event, data) => {
                  validateFeeAmount(group.id, event.target.value);
                  handleEventChange(getUpdatedFormFees(groupFee, group.id, event.target.value));
                }}
              />

              <div
                role="button"
                className="apply-to-all u-spaceTopLg"
                onClick={() => handleApplyAll(groupFee.amount)}
                onKeyDown={() => {}}
                tabIndex={group.id}
              >
                Apply to all
              </div>
            </div>
          </div>
        );
      });

  if (isSavedGroupsLoading) {
    return (
      <div className="Loader-indicator">
        <span className="SpinAnimation" />
        <div className="Loader-indicatorText">Loading participant groups...</div>
      </div>
    );
  }

  if (!isSavedGroupsLoading && formGroups.length === 0) {
    return (
      <div className="Loader-indicator">
        <div className="Loader-indicatorText">No participant groups defined.</div>
      </div>
    );
  }

  return <div className="group-fees-wrapper">{formatGroupFees()}</div>;
};

export default GroupFees;
